import { API_BASE_URL } from "../config/envConstants";

export const API_VERSION = "v1";
export const API_URL_SUFFIX = "/api/";
export const MACHINES_API_PREFIX = `${API_VERSION}/machines`;
export const MACHINES_API_URL =
  API_BASE_URL + API_URL_SUFFIX + MACHINES_API_PREFIX;
